module.exports = __webpack_public_path__ + "img/40_38_034_130.aa6b0dfc.jpg";